export default {
      id: "mission-touroperator-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "img/icons.ece5aa3c.svg#mission-touroperator",
      toString: function () {
        return this.url;
      }
    }